/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Room from './room';
import RoomDetail from './room-detail';
import RoomUpdate from './room-update';
import RoomDeleteDialog from './room-delete-dialog';

const RoomRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Room />} />
    <Route path="new" element={<RoomUpdate />} />
    <Route path=":id">
      <Route index element={<RoomDetail />} />
      <Route path="edit" element={<RoomUpdate />} />
      <Route path="delete" element={<RoomDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RoomRoutes;
